import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=37f58b0c&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=ts&"
export * from "./myList.vue?vue&type=script&lang=ts&"
import style0 from "./myList.vue?vue&type=style&index=0&id=37f58b0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f58b0c",
  null
  
)

export default component.exports